
const Dashboard = () => {
  const current_user = JSON.parse(localStorage.getItem('user'))
  return (
    <>
      <div className="card">
        <div className="card-header p-2 bg-primary text-white d-flex justify-content-center">
          <h3 className="card-title">WELCOME TO KOBCIYE UTILITY BILLING SYSTEM</h3>
        </div>
        <div className="card-body"></div>
      </div>
      <div className="row">
        <div className="col-md-4">
          
        </div>
      </div>
    </>
  )
}

export default Dashboard
